import request from '@/utils/request'

//从环境变量获取auth服务的路径
const VUE_APP_ROLE_PATH = process.env.VUE_APP_ROLE_PATH

//初始化state
const state = {
    
}
  
//定义getter
const getters = {

}

//定义同步的操作，即mutation
const mutations = {
    
}

//定义异步的操作，即action
const actions = {
    // 查询部门列表
    // eslint-disable-next-line no-unused-vars
    async getDeptList({ commit }, { deptName }) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/dept/list`
        const result = await request.get(url, {params:{
            deptName: deptName
        }});
        //获取服务返回数据
        return result
    },
    // 添加部门
    async addDept(state, params){
        let url = `${VUE_APP_ROLE_PATH}/dept`;
        const result = await request.post(url, params);
        return result;
    },
    // 修改部门
    async updateDept(state, data){
        let url = `${VUE_APP_ROLE_PATH}/dept`;
        const result = await request.put(url, data);
        return result;
    },
    // 删除部门
    async delDept({ commit }, { deptId }){
        let url = `${VUE_APP_ROLE_PATH}/dept/${deptId}`;
        const result = await request.delete(url);
        return result
    },
    // 查询部门详情
    async getDept({ commit }, { deptId }) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/dept/${deptId}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result
    },
    // 查询部门列表（排除节点）
    async listDeptExcludeChild({ commit }, { deptId }) {
        //发起request
        const url = `${VUE_APP_ROLE_PATH}/dept/list/exclude/${deptId}`;
        const result = await request.get(url);
        //获取服务返回数据
        return result
    }
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }